"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.IconDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_icons_1 = require("../../hooks/use-icons");
;
exports.IconDefaultProps = {
  color: 'dark',
  type: 'icon',
  ratio: 1
};
// -------- Styles -------->
var sizeIsNumber = function (size) {
  return typeof size === 'number';
};
var sizeFor = function (breakpoint) {
  return function (props) {
    if (sizeIsNumber(props.size)) {
      return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), props.ratio * props.size, props.size);
    }
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), theme_1.theme.GRID_SIZE(props.type, props.size, breakpoint), theme_1.theme.GRID_SIZE(props.type, props.size, breakpoint));
  };
};
var fill = function (props) {
  return props.color && props.color !== 'none' && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), theme_1.theme.FILL(props.color));
};
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n    ", "\n    display: flex;\n    align-items: center;\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  "], ["\n    ", "\n    ", "\n    display: flex;\n    align-items: center;\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  "])), fill, sizeFor('base')),
  landscape: sizeFor('base'),
  tablet: sizeFor('tablet'),
  desktop: sizeFor('desktop'),
  desktopLarge: sizeFor('desktop-large')
});
// -------- Icons -------->
var My = {
  Container: styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
exports.Icon = React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    size = props.size,
    type = props.type,
    color = props.color,
    component = props.component,
    ratio = props.ratio,
    onClick = props.onClick,
    title = props.title;
  var Icons = (0, use_icons_1.useIcons)();
  var handleClick = onClick ? function (e) {
    e.stopPropagation();
    onClick();
  } : null;
  // @ts-ignore
  var SVG = component && (Icons[component] || Icons[component.replace(/Icon$/, '')]);
  return React.createElement(My.Container, {
    ref: ref,
    title: title,
    onClick: handleClick,
    ratio: ratio,
    size: size,
    type: type,
    color: color,
    className: className
  }, component && SVG ? React.createElement(SVG, null) : children);
});
exports.Icon.defaultProps = exports.IconDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;